export default "__VITE_ASSET__B$u1L1WO__"